import {
  getExhibitionistStripWidgetConfig,
  getExhibitionistGridWidgetConfig,
} from '@wix/da-shared-react/pkg/widgets/Exhibitionist/widgetConfig';
import {
  getFeaturedDeviationWidgetConfig,
  getFeaturedPostWidgetConfig,
} from '../../UserWidgets.deviation_gruser/FeaturedDeviation/widgetConfig';
import {
  getWatchersWidgetConfig,
  getWatchingWidgetConfig,
} from '../../UserWidgets.deviation_gruser/WatchedDeviants/widgetConfig';
import { getSupportersWidgetConfig } from '../../UserWidgets.deviation_gruser/Supporters/widgetConfig';
import {
  getGroupListAdminsWidgetConfig,
  getGroupListMembersWidgetConfig,
} from '../../UserWidgets.deviation_gruser/GroupList/widgetConfig';
import { getFeedWidgetConfig } from '../../UserWidgets.deviation_gruser/Feed/widgetConfig';
import { getProfileCommentsWidgetConfig } from '../../UserWidgets.deviation_gruser/ProfileComments/widgetConfig';
import { getLlamaFarmWidgetConfig } from '../../UserWidgets.deviation_gruser/LlamaFarm/widgetConfig';
import { getDonationsWidgetConfig } from '../../UserWidgets.deviation_gruser/Donations/widgetConfig';
import { getGroupAdminsWidgetConfig } from '../../GroupWidgets.deviation_gruser/Admins/widgetConfig';
import getActiveMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/ActiveMembers/widgetConfig';
import getGroupMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/GroupMembers/widgetConfig';
import getNewestMembersWidgetConfig from '../../GroupWidgets.deviation_gruser/NewestMembers/widgetConfig';
import { getTiersPromoWidgetConfig } from '../../UserWidgets.deviation_gruser/TiersPromoBox/widgetConfig';

// TODO:
// This should be a simple widgetName to widgetConfig map
// Which widgets are installable to which zones is back-end controlled and
// should not be hard-coded
export const getHomeWidgetConfigs = ({ t, dispatch }) => ({
  topBar: {
    exhibitionist: getExhibitionistStripWidgetConfig({ t, dispatch }),
    tiers: getTiersPromoWidgetConfig({ t, dispatch }),
  },
  bottomLeft: {
    exhibitionist: getExhibitionistGridWidgetConfig({ t, dispatch }),
    featuredDeviation: getFeaturedDeviationWidgetConfig({ t, dispatch }),
    watchers: getWatchersWidgetConfig({ t, dispatch }),
    watching: getWatchingWidgetConfig({ t, dispatch }),
    supporters: getSupportersWidgetConfig({ t, dispatch }),
    groupListMembers: getGroupListMembersWidgetConfig({ t, dispatch }),
    groupListAdmins: getGroupListAdminsWidgetConfig({ t, dispatch }),
    llamaFarm: getLlamaFarmWidgetConfig({ t, dispatch }),
    groupAdmins: getGroupAdminsWidgetConfig({ t, dispatch }),
    activeMembers: getActiveMembersWidgetConfig({ t, dispatch }),
    groupMembers: getGroupMembersWidgetConfig({ t, dispatch }),
    newestMembers: getNewestMembersWidgetConfig({ t, dispatch }),
  },
  midRight: {
    featuredPost: getFeaturedPostWidgetConfig({ t, dispatch }),
    feed: getFeedWidgetConfig({ t, dispatch }),
    llamaFarm: getLlamaFarmWidgetConfig({ t, dispatch }),
    donations: getDonationsWidgetConfig({ t, dispatch }),
  },
  bottomRight: {
    comments: getProfileCommentsWidgetConfig({ t, dispatch }),
  },
});
